import { useTranslation } from 'react-i18next';
import './navigation.scss';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
    {label:'home',path:'/'},
    {label:'bio',path:'/about'},
    {label:'portfolio',path:'/portfolio'},
    {label:'reviews',path:'/reviews'},
    {label:'legal-notice',path:'/legal-notice', hide:true},
    {label:'privacy-policy',path:'/privacy-policy', hide:true},
    {label:'juine_canvases',path:'/juine-canvases'},
    {label:'contact',path:'/contact'},
]
const defaultLang = import.meta.env.VITE_DEFAULT_LANG;

export function Navigation({ isMobileActive }: {isMobileActive: boolean}){
   
    const location = useLocation();
    const lang =location.pathname.split('/')[1] ?? defaultLang;
    const routePath = '/' + location.pathname.split('/')[2]
    const { t } = useTranslation();
    return(
        <>

            <nav className={ `navigation-container ${isMobileActive? 'show' :'hide'}`}>
                <ul className="navigation-menu">
                    {navLinks.map((navItem)=>(
                        navItem.hide?'':
                        <li key={'/' + lang + navItem.path}
                             className={(routePath===navItem.path)?'active':''}>
                            <Link 
                                to={'/' + lang + navItem.path}>
                                {t(`${navItem.label}.label`)}
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>
            
        </>
    )
}